export default __webpack_public_path__ + "static/media/User-ConTarjeta.dceb3b4e.svg";